import { ICellCss, ICol, IGridConfig, IRow, ISpan } from "../types";
import { rgbToHex } from "@dhx/ts-common/core";
import { locateNode } from "@dhx/ts-common/html";

export function transpose(arr: any[][], transform?: any): any[][] {
	const columns = [];
	for (let i = 0; i < arr.length; i++) {
		const row = arr[i];
		for (let cellInd = 0; cellInd < row.length; cellInd++) {
			columns[cellInd] = columns[cellInd] || [];
			const cell = transform ? transform(row[cellInd]) : row[cellInd];
			columns[cellInd].push(cell);
		}
	}
	return columns;
}

function insert(node: HTMLElement, newone: string | HTMLElement): HTMLElement {
	if (typeof newone === "string") {
		node.insertAdjacentHTML("beforeend", newone);
		return node.lastChild as HTMLElement;
	} else {
		node.appendChild(newone);
		return newone;
	}
}

export function getStyleByClass(
	cssClass: string,
	container: HTMLElement,
	targetClass: string,
	def?: ICellCss
): ICellCss {
	const cont = container.querySelector("." + targetClass) as HTMLElement;

	const testDiv = insert(cont, `<div class="${cssClass}"></div>`);
	const styles = window.getComputedStyle(testDiv);
	const result = {
		color: styles.color === "rgb(0, 0, 0)" ? def.color : rgbToHex(styles.color),
		background:
			styles.backgroundColor === "rgba(0, 0, 0, 0)" ? def.background : rgbToHex(styles.backgroundColor),
		fontSize: parseFloat(styles.fontSize),
	};
	cont.removeChild(testDiv);
	// [dirty]
	if (
		result.color === def.color &&
		result.background === def.background &&
		result.fontSize === def.fontSize
	) {
		return null;
	}
	return result;
}

export function removeHTMLTags(str: string): string {
	if (typeof str !== "string" && typeof str !== "number" && typeof str !== "boolean") {
		return "";
	}
	return `${str === undefined || str === null ? "" : str}`
		.replace(/<[^>]*>/g, "")
		.replace(/["]/g, "&quot;")
		.trim();
}

export function isCssSupport(property: string, value: string): boolean {
	try {
		return CSS.supports(property, value);
	} catch (err) {
		const el = document.createElement("div");
		el.style[property] = value;
		return el.style[property] === value;
	}
}

export function isRowEmpty(row: IRow): boolean {
	if (!row) {
		return;
	}
	return Object.keys(row).reduce((acc, col) => {
		if (col === "id" || col.startsWith("$")) {
			return acc;
		}
		if (acc && row[col] !== undefined && row[col] !== "") {
			return;
		}
		return acc;
	}, true);
}

export function isSortable(config: IGridConfig, col: ICol) {
	return (col.sortable !== false && config.sortable) || col.sortable;
}

export function isAutoWidth(config: IGridConfig, col?: ICol) {
	if (col) {
		return (col.autoWidth !== false && config.autoWidth) || col.autoWidth;
	}
	let check = false;
	config.columns.map(col => {
		if ((col.autoWidth !== false && config.autoWidth) || col.autoWidth) {
			check = true;
			return;
		}
	});
	return check;
}

export function isTooltip(config: IGridConfig, element: ICol | ISpan) {
	return (element.tooltip !== false && config.tooltip) || element.tooltip;
}

export function isHtmlEnable(config: IGridConfig, col: ICol) {
	return (col.htmlEnable !== false && config.htmlEnable) || col.htmlEnable;
}

export function getTotalWidth(columns: ICol[]) {
	return columns.reduce((total, col) => total + (col.$width || 0), 0);
}

export function getTotalHeight(rows: IRow[]) {
	return rows.reduce((total, row) => total + (row.$height || 0), 0);
}

export function scrollFixedColsAndRows(e: WheelEvent): void {
	const grid = locateNode(e, "data-dhx-widget-id");
	const gridBody = grid.querySelector(".dhx_grid-body");
	const delta = e.deltaY;
	const position = e.shiftKey ? [delta, 0] : [0, delta];
	gridBody?.scrollBy(...(position as any[]));
}
